import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import { FooterProps } from '.'

// Extend the Window interface to include OneTrust
declare global {
  interface Window {
    OneTrust?: any
  }
}

export const useFooterProps = (): FooterProps => {
  const { t } = useTranslation()

  return useMemo(
    () => ({
      links: [
        {
          link: {
            href: t('footer.legal.href'),
          },
          text: t('footer.legal.text'),
        },
        {
          onClick: () => window.OneTrust.ToggleInfoDisplay(),
          text: t('footer.policy.text'),
        },
        {
          link: {
            href: t('footer.balenciaga.href'),
            target: '_blank',
          },
          text: t('footer.balenciaga.text'),
        },
      ],
    }),
    [t]
  )
}
